import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Results() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Results
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Results
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Results-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Construct design and cloning
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Results-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Target gene expression verification
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Results-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine concentration measurement
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Results-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Construct design and cloning
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div className="font-bold">
                                Expression construct (BBa_K5122003):
                            </div>
                            <div className="mt-5">
                                cDNA sequences of the genes of interest (GuaA, GuaB) plus a chromogenic protein
                                (aeBlue) cDNA were commercially synthesized in a single insert, which was amplified
                                via PCR using Phusion polymerase,  and cloned into pET45b+ plasmid backbone with
                                AmpR gene, using HindIII and SacI cloning sites. The acquired construct was
                                transformed into chemically competent E. coli Top10 cells and cells were outgrown
                                in ampicillin+ LB media to select for positive clones. The success of the cloning
                                was verified by plasmid restriction digest and agarose electrophoresis. The plasmid
                                was also sent for whole-plasmid sequencing.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/results/results-1.png"
                                className="w-full mt-5"
                                alt=""
                            />
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div className="font-bold">
                                Silencing construct:
                            </div>
                            <div className="mt-5">
                                The silencing construct contained cDNA of deadCas9 enzyme and a guide RNA code in on
                                brick. The construct was ordered from a commercial supplier, with intention to clone
                                it into pET45+ plasmid backbone for simultaneous dCas9 and gRNA expression in the
                                transformed E.coli cells. However, the synthesis of the construct was not possible
                                due to the complex nature of the sequence and thus we had to reconsider the construct
                                design.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/results/results-2.png"
                                className="w-full mt-5"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Results-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Target gene expression verification
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The target genes expression was confirmed by SDS-PAGE, where induced and uninduced
                                E.coli culture lysates were run on an SDS-PAGE and band patterns of uninduced and
                                IPTG-induced cultures several hours post-induction were compared to each other.
                                Thick bands of sizes of 58.7 KDa (GuaA) and 52 KDa (GuaB) were observed only in the
                                induced cultures, confirming target enzyme expression. There was no band
                                corresponding to aeBlue observed.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/results/results-3.png"
                                className="w-full mt-5 max-w-xl mx-auto"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Results-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Guanine concentration measurement
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                For guanine concentration measurement we utilized commercial Guanine Assay Kit
                                (Cell Biolabs). For guanine concentration determination, a cell expansion was
                                realized, first by an uninduced culture and secondly IPTG-induced cultures were
                                established. Then the cultures were centrifuged and resuspended in PBS, then
                                diluted until the OD was in the readable range (0.3-1). In this range, the
                                concentration can be calculated as well as the volume necessary to realize solutions
                                of the concentration necessary for the assay kit (1-2 * 10⁶ cells/mL in PBS). The
                                samples are sonicated and the assay was realized.
                            </div>
                            <div className="mt-5">
                                The results obtained from the assay were not conclusive as the standard measurements
                                were not adequate due to unknown reasons. The test was repeated 3 times with three
                                different kits (two colometric and one fluorescence).
                            </div>
                        </div>
                    </div>


                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}